import type { FC, PropsWithChildren } from 'react';

import { Modal } from '@/core/tamagoshi/Modal/Modal';
import { ModalContent } from '@/core/tamagoshi/Modal/ModalContent';
import { ModalFooter } from '@/core/tamagoshi/Modal/ModalFooter';
import { ModalHeader } from '@/core/tamagoshi/Modal/ModalHeader';
import { Typography } from '@/core/tamagoshiv2/components/Typography/Typography';
import { Button } from '@/domains/core/tamagoshiv2/components/Button/Button';
import { NavigationButton } from '@/domains/core/tamagoshiv2/components/Button/NavigationButton';
import { formatTitle } from '@/domains/shoppingCart/AddToCart/utils/formatTitle';
import type { AddToCartModalProps } from '@/shoppingCart/AddToCart/components/MinimalisticAddToCartModal/interfaces';
import { viewBasket } from '@/shoppingCart/AddToCart/translations';
import { continueShopping } from '@/shoppingCart/CartPage/translations';
import { CART_URL } from '@/shoppingCart/routes';

import styles from './addToCartModal.module.scss';

export const AddToCartModalScaffold: FC<
  PropsWithChildren<AddToCartModalProps>
> = ({ onClose, children, savedProductIds, products }) => {
  const formattedTitle = formatTitle(savedProductIds, products, 'longer');

  return (
    <Modal
      onClose={onClose}
      className={styles.modal}
      maxWidth="lg"
      trapFocus={false}
      hasPadding={false}
      isCloseButtonVisible
      data-testid="add-to-cart-modal"
    >
      <ModalHeader className={styles.header}>
        <Typography type="title" variant="h3">
          {formattedTitle}
        </Typography>
      </ModalHeader>
      <ModalContent>{children}</ModalContent>
      <ModalFooter className={styles.footer}>
        <NavigationButton
          content={viewBasket}
          href={CART_URL}
          type="primary"
          onClick={onClose}
          data-testid="go-to-cart-page-cta"
          size="L"
        />
        <Button
          content={continueShopping}
          type="secondary"
          onClick={onClose}
          data-testid="close-modal-cta"
          size="L"
        />
      </ModalFooter>
    </Modal>
  );
};
